import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import LegalPage from "./pages/LegalPage";
import CookieBanner from "./components/legal/CookieBanner";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/legal/:slug" element={<LegalPage />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster position="bottom-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
